// 99% of this is identical to guild rec page...need to make these things shared
import _ from 'lodash';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterRecruitmentPageState } from '../libs/store';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { stripPathLocale } from '../../../../../shared/common/localeShared';

const getInitialState = (): TCharacterRecruitmentPageState => ({
  loaded: false,
  loading: false,
  error: false,
  profiles: [],
  message: '',
  applicationModalOpen: false,
  sourceProfileId: -1,
  targetProfileId: -1,
  recruitmentProfileDetails: [],
  currentEntityId: -1,
  errorMessage: '',
  application: {
    loading: false,
    loaded: false,
    error: false,
    threadId: -1
  }
});

const LOAD_CHARACTER_RECRUITMENT_PROFILE = 'CHARACTER/RECRUITMENT/LOAD_PROFILES';
const LOAD_CHARACTER_RECRUITMENT_PROFILE_SUCCESS = 'CHARACTER/RECRUITMENT/LOAD_PROFILES_SUCCESS';
const LOAD_CHARACTER_RECRUITMENT_PROFILE_FAIL = 'CHARACTER/RECRUITMENT/LOAD_PROFILES_FAIL';

const loadCharacterRecruitmentProfiles = (currentEntityId: number) => ({
  type: LOAD_CHARACTER_RECRUITMENT_PROFILE,
  // reset profiles state, otherwise we'll end up trying to format profiles that
  // aren't relevant and blowing up.
  payload: { currentEntityId, loaded: false, loading: true, profiles: [] }
});
const loadCharacterRecruitmentProfileSuccess = (profiles: any) => ({
  type: LOAD_CHARACTER_RECRUITMENT_PROFILE_SUCCESS,
  payload: { profiles, loaded: true, loading: false }
});
const loadCharacterRecruitmentProfileFail = () => ({
  type: LOAD_CHARACTER_RECRUITMENT_PROFILE_FAIL,
  payload: { error: true, loaded: true }
});

const TOGGLE_APPLY_MODAL_VISIBILITY = 'CHARACTER/RECRUITMENT/TOGGLE_APPLY_MODAL';
const toggleApplyModal = () => ({ type: TOGGLE_APPLY_MODAL_VISIBILITY });

const REQUEST_APPLICATION = 'CHARACTER/RECRUITMENT/REQUEST_APPLICATION';
const REQUEST_APPLICATION_SUCCESS = 'CHARACTER/RECRUITMENT/REQUEST_APPLICATION_SUCCESS';
const REQUEST_APPLICATION_FAIL = 'CHARACTER/RECRUITMENT/REQUEST_APPLICATION_FAIL';
const requestApplication = (targetProfileId: number) => ({
  type: REQUEST_APPLICATION,
  payload: {
    application: {
      loading: true,
      loaded: false,
      error: false
    }
  }
});

const SET_TARGET_PROFILE_ID = 'CHARACTER/RECRUITMENT/SET_TARGET_PROFILE_ID';
const setTarget = (targetProfileId: number) => ({
  type: SET_TARGET_PROFILE_ID,
  payload: {
    targetProfileId
  }
});

const requestApplicationSuccess = (threadId: number) => ({
  type: REQUEST_APPLICATION_SUCCESS,
  payload: {
    application: {
      threadId,
      loading: false,
      loaded: true,
      error: false
    }
  }
});
const requestApplicationFail = (errorMessage?: string) => ({
  type: REQUEST_APPLICATION_FAIL,
  payload: {
    errorMessage,
    application: {
      error: true,
      loaded: true,
      loading: false
    }
  }
});

const SET_APPLICATION_MSG = 'CHARACTER/RECRUITMENT/SET_APPLICATION_MSG';
const SET_SOURCE_PROFILE = 'CHARACTER/RECRUITMENT/SET_SOURCE_PROFILE';
const setApplicationMessage = (message: string) => ({
  type: SET_APPLICATION_MSG,
  payload: { message }
});
const setSourceProfile = (sourceProfileId: number) => ({
  type: SET_SOURCE_PROFILE,
  payload: { sourceProfileId }
});

function characterRecruitmentPageReducer(
  // state: TCharacterRecruitmentPageState = initialState,
  state: any = getInitialState(),
  action: TAction<any>
): TCharacterRecruitmentPageState {
  switch (action.type) {
    case LOAD_CHARACTER_RECRUITMENT_PROFILE:
    case LOAD_CHARACTER_RECRUITMENT_PROFILE_SUCCESS:
    case LOAD_CHARACTER_RECRUITMENT_PROFILE_FAIL:
    case REQUEST_APPLICATION:
    case REQUEST_APPLICATION_SUCCESS:
    case REQUEST_APPLICATION_FAIL:
    case SET_APPLICATION_MSG:
    case SET_TARGET_PROFILE_ID:
    case SET_SOURCE_PROFILE: {
      return { ...state, ...action.payload };
    }

    case TOGGLE_APPLY_MODAL_VISIBILITY: {
      const { applicationModalOpen } = state;
      if (applicationModalOpen) {
        return {
          ...state,
          ..._.pick(getInitialState(), [
            'targetProfileId',
            'sourceProfileId',
            'message',
            'errorMessage',
            'application'
          ]),
          applicationModalOpen: false
        };
      }
      return { ...state, applicationModalOpen: true };
    }
    case LOCATION_CHANGE: {
      const location = stripPathLocale(action.payload.location.pathname);
      if (!location.match('/characters/')) {
        return getInitialState();
      }
    }
    default:
      return state;
  }
}

export const actions = {
  loadCharacterRecruitmentProfiles,
  loadCharacterRecruitmentProfileSuccess,
  loadCharacterRecruitmentProfileFail,

  toggleApplyModal,

  requestApplication,
  requestApplicationSuccess,
  requestApplicationFail,

  setApplicationMessage,
  setSourceProfile,

  setTarget
};

export const actionTypes = {
  LOAD_CHARACTER_RECRUITMENT_PROFILE,
  REQUEST_APPLICATION
};

export default characterRecruitmentPageReducer;
